import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router'
import { PageWidthDefault } from '@/components/page'
import { SettingsScreen } from '@/features/settings/routes/settings-screen'

export const Route = createFileRoute('/settings')({ component: SettingsLayout })

function SettingsLayout() {
  // A child route (Users, System) owns the whole screen. Rendering the
  // Settings list above it stacked two page headers on one page.
  const matches = useMatches()
  const hasChild = matches.some(
    (match) => match.routeId !== '/settings' && match.routeId.startsWith('/settings/'),
  )

  // Everything under /settings is centred at the settings width — set once
  // here, so a new settings page gets it without asking (docs/LAYOUT.md).
  return (
    <PageWidthDefault value="settings">
      {hasChild ? <Outlet /> : <SettingsScreen />}
    </PageWidthDefault>
  )
}
